import React, { useEffect, useState } from "react";
import "./login.css";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Footer from "../Footer/Footer";
import {
  GoogleAuthProvider,
  signInWithPopup,
  FacebookAuthProvider,
} from "firebase/auth";
import { auth } from "../../../firebase";
import { ImFacebook2 } from "react-icons/im";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import Header from "../Header/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isLoginAPI, socialLogin } from "../../../Helper/Redux/API";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
const Login = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [registertype, setRegisterType] = useState("2");
  const [roleid, setIsRoleId] = useState("1");

  // useEffect(() => {
  //   if (localStorage.getItem("access_token")) {
  //     navigate("/Calendar", { replace: true });
  //   }
  // }, []);

  const initialValues = {
    password: "",
    email: "",
  };
  // Define the form submission function
  const onSubmit = (values, { resetForm }) => {
    // Handle form submission logic here
    dispatch(isLoginAPI(values)).then((res) => {
      if (res?.payload?.status == true) {
        let access_token = res?.payload?.access_token;
        let Userid = res?.payload?.user.id;
        let Roleid = res?.payload?.user?.roles[0].id;
        // let testcheck = res?.payload?.user?.is_test;
        // console.log("red", res?.payload.user.is_test);
        toast.success(res?.payload?.message);
        if (access_token != "" && access_token != "") {
          localStorage.setItem("access_token", access_token);
          // localStorage.setItem("testtrue", testcheck);

          localStorage.setItem("id", Userid);
          localStorage.setItem("Roleid", Roleid);
          localStorage.setItem("UserName", res?.payload?.user?.first_name);
          localStorage.setItem("lastName", res?.payload?.user?.last_name);

          // if (testcheck != "1") {
          //   navigate("/Heartest");
          // } else {
          //   navigate("/Calendar");
          // }
          navigate("/Calendar");
          // toast.success(res.payload.message);
        }
      } else {
        toast.error(res?.payload?.message);
      }
    });
  };
  const validation = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  ////////////////////////////////// CODE START FOR SIGN UP WITH GOOGLE
  const googlesignIn = () => {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(auth, provider);
  };
  const handlegoogleSignIn = async () => {
    try {
      const result = await googlesignIn();
      const user = result.user;
      setEmail(user.email);
      setFirstName(user.displayName);
      setLastName(user.displayName);
      setToken(user.accessToken);
      const requestBody = {
        first_name: user.displayName,
        // last_name: user.displayName,
        email: user.email,
        token: user.accessToken,
        role_id: "2",
        register_type: "1",
      };
      // console.log("Google Sign-In successful. User information:", user);

      dispatch(socialLogin(requestBody)).then((res) => {
        if (res?.payload?.status == true) {
          // console.log("red", res);
          // toast.success(res?.payload?.message);
          if (
            res?.payload?.access_token != "" &&
            res?.payload?.access_token != ""
          ) {
            localStorage.setItem("access_token", res?.payload?.access_token);
            localStorage.setItem(
              "UserName",
              res?.payload?.store_data?.first_name
            );
            localStorage.setItem("Roleid", "2");
            localStorage.setItem("id", res?.payload?.store_data.id);
            // localStorage.setItem("lastName", Userlast);
            navigate("/Calendar");
            toast.success(res?.payload?.message);
          }
        } else {
          toast.error(res?.payload?.message);
        }
      });
    } catch (error) {
      // console.log("Google Sign-In gave an error:", error);
    }
  };

  // Define the form submission function

  /////////////////////////////////////////CODE END  FOR SIGN UP WITH GOOGLE

  ////////////////////////////////// CODE START FOR SIGN UP WITH FACEBOOK
  const faceBooksignIn = () => {
    const fbprovider = new FacebookAuthProvider();
    return signInWithPopup(auth, fbprovider);
  };
  const handleFaceBookSignIn = async () => {
    try {
      const result = await faceBooksignIn();
      const user = result.user;
      const requestBody = {
        first_name: user.displayName,
        // last_name: user.displayName,
        email: user.email,
        token: user.accessToken,
        role_id: "2",
        register_type: "2",
      };
      // console.log("fff", user);

      dispatch(socialLogin(requestBody)).then((res) => {
        if (res?.payload?.status == true) {
          // console.log("red", res);
          // toast.success(res?.payload?.message);
          if (
            res?.payload?.access_token != "" &&
            res?.payload?.access_token != ""
          ) {
            localStorage.setItem("access_token", res?.payload?.access_token);
            localStorage.setItem(
              "UserName",
              res?.payload?.store_data.first_name
            );
            localStorage.setItem("id", res?.payload?.store_data.id);
            localStorage.setItem("Roleid", "2");
            // localStorage.setItem("lastName", Userlast);
            navigate("/Calendar");
            toast.success(res?.payload?.message);
          }
        } else {
          toast.error(res?.payload?.message);
        }
      });
      // console.log("FaceBook Sign-In successful. User information:", user);
    } catch (error) {
      // console.log("FaceBook Sign-In gave an error:", error);
    }
  };
  /////////////////////////////////////////CODE END  FOR SIGN UP WITH FACEBOOK
  const [selectedOption, setSelectedOption] = useState("1"); // Default selected option

  const handleSelectChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <Header />

      <section className="log_form login_all">
        <div className="container">
          <div className="row log_div">
            <div className="col-lg-4 g-0">
              <div className="Fomr_text">
                <h2 className="wow  fadeInUp  animated">Hello, Friends!</h2>
                <p className="wow  slideInLeft animated">
                  Enter your personal details and start journey with us
                </p>
                <Link to="/Signup">
                  {" "}
                  <button className="btn wow  slideInUp animated">
                    Sign Up
                  </button>
                </Link>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="form-container login_form py-4">
                <h1 className="wow  zoomIn animated">
                  Welcome back. <br /> Sign in to your account
                </h1>
                <Formik
                  initialValues={initialValues}
                  onSubmit={onSubmit}
                  validationSchema={validation}
                >
                  <Form>
                    <div className="input_container wow fadeInRight  animated">
                      {/* <div className="form_input">
                        <Field
                          as="select"
                          name="Mobile"
                          className="form-select"
                          aria-label="Mobile"
                          onChange={handleSelectChange}
                        >
                          <option value="1" selected={selectedOption === "1"}>
                            By Email
                          </option>
                          <option value="2" selected={selectedOption === "2"}>
                            By Mobile
                          </option>
                        </Field>
                      </div> */}
                      {selectedOption === "1" && (
                        <>
                          <div className="form_input">
                            <Field
                              type="email"
                              name="email"
                              id="login_email"
                              placeholder="Enter your Email"
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                          <div className="form_input password_hide">
                            <Field
                              type={showPassword ? "text" : "password"}
                              name="password"
                              id="login_password"
                              placeholder="Enter your password"
                            />
                            <span
                              className="password-toggle-icon"
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                              />
                            </span>
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="text-danger"
                            />
                          </div>{" "}
                        </>
                      )}
                      {selectedOption === "2" && (
                        <>
                          <div className="form_input">
                            <Field
                              type="number"
                              name="number"
                              id="login_number"
                              placeholder="Enter your Number"
                            />
                            {/* <ErrorMessage
                              name="email"
                              component="div"
                              className="text-danger"
                            /> */}
                          </div>
                          <div className="form_input">
                            <Field
                              type="number"
                              name="OTP"
                              id="login_OTP"
                              placeholder="Enter your OTP"
                            />
                            {/* <ErrorMessage
                              name="password"
                              component="div"
                              className="text-danger"
                            /> */}
                          </div>{" "}
                        </>
                      )}
                      <Link to="/ForgotPass" className="Forget_text">
                        {" "}
                        Forgot Password ?{" "}
                      </Link>{" "}
                      <br />
                      <button className="btn" type="submit">
                        Sign In
                      </button>
                    </div>
                  </Form>
                </Formik>
                <div className="social_signup_btn_cont wow fadeInRight  animated">
                  <button className="" onClick={() => handlegoogleSignIn()}>
                    {" "}
                    <FcGoogle className="google_logo common_logo_size" /> Login
                    with Google
                  </button>

                  {/* <button>
                <FaApple className="apple_logo common_logo_size" />

                <span> Login with Apple </span>
              </button> */}
                  <button
                    className="wow fadeInRight  animated"
                    onClick={() => handleFaceBookSignIn()}
                  >
                    {" "}
                    <ImFacebook2 className="facebook_logo common_logo_size " />
                    <span> Login with Facebook </span>
                  </button>
                </div>

                {/* <p className="text-center mt-4">
                  Do you want to{" "}
                  <Link onClick={() => props.setTabType("registered")}>
                    {" "}
                    create new account?{" "}
                  </Link>
                </p> */}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Login;
